/** localStorage 键名，与 public/index.html 内联脚本保持一致 */
export const THEME_STORAGE_KEY = "theme";

/** @returns {'dark' | 'light' | null} */
export function readStoredTheme() {
  if (typeof window === "undefined") return null;
  try {
    const saved = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (saved === "dark" || saved === "light") return saved;
  } catch (e) {
    // ignore
  }
  return null;
}

/** 将主题同步到 DOM，供首屏脚本与 React 共用 */
export function applyThemeToDocument(theme) {
  if (typeof document === "undefined") return;
  if (theme === "dark" || theme === "light") {
    document.documentElement.setAttribute("data-theme", theme);
  }
}
